module.exports = " <div class=ui> <div class=navbar-wrapper> <div class=navbar> <div class=left> </div> <div class=title>PACO-UI</div> <div class=right></div> </div> </div> <div style=\"margin: 20px\"> <br> <div class=t1>t1-用于titlebar标题文案</div> <br> <div class=t2>t2-仅用于按钮提示文字</div> <br> <div class=t3>t3-用于列表/表单 标签/标题文案</div> <br> <div class=t4>t4-用于列表/表单右侧说明文案</div> <br> <div class=t5>t5-用于列表/表单等辅助字体</div> <br> <div class=t6>t6-用于列表/表单下方说明文字</div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/text.vue
// module id = 164
// module chunks = 1